import React from 'react';
import { Circle, Path, Svg } from 'react-native-svg';
import { useUnistyles } from 'react-native-unistyles';

import type { AppColors } from '@squire/ui';

interface UserIconProps {
  size?: number;
  color?: keyof AppColors;
}

export const UserIcon: React.FC<UserIconProps> = ({
  size = 24,
  color = 'iconPrimary',
}) => {
  const { theme: colors } = useUnistyles();
  return (
    <Svg width={size} height={size} viewBox="0 0 24 24" fill="none">
      <Circle cx={12} cy={8} r={4} fill={colors[color]} />
      <Path d="M6 20c0-3.314 2.686-6 6-6s6 2.686 6 6" fill={colors[color]} />
    </Svg>
  );
};
